// extracted by mini-css-extract-plugin
export var infoItem = "_ou-2";
export var title = "_ou-0";
export var value = "_ou-1";